import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { Plus, Pencil, Trash2, X, Check, Truck } from 'lucide-react';

export default function VehiculosPage() {
  const [vehiculos, setVehiculos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [tiposVehiculo, setTiposVehiculo] = useState([]);
  const [form, setForm] = useState({ placas:'', numero_economico:'', marca:'', modelo:'', anio:'', color:'', vin:'', id_dispositivo_gps:'', imei:'', tipo_vehiculo_id:'', cliente_id:'', activo:true, notas:'' });

  const fetchVehiculos = async () => {
    setLoading(true);
    try { const res = await api.get('/catalogos/vehiculos'); setVehiculos(res.data.data); }
    catch(e) { toast.error('Error al cargar vehículos'); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    fetchVehiculos();
    Promise.all([api.get('/catalogos/clientes?activo=true'), api.get('/catalogos/tipos-vehiculo')])
      .then(([c,t]) => { setClientes(c.data.data); setTiposVehiculo(t.data.data); });
  }, []);

  const openCreate = () => { setForm({ placas:'', numero_economico:'', marca:'', modelo:'', anio:'', color:'', vin:'', id_dispositivo_gps:'', imei:'', tipo_vehiculo_id:'', cliente_id:'', activo:true, notas:'' }); setEditItem(null); setShowModal(true); };
  const openEdit = (v) => { setForm({ ...v, activo: !!v.activo }); setEditItem(v); setShowModal(true); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const body = { ...form };
      if (!body.anio) delete body.anio;
      if (editItem) { await api.put(`/catalogos/vehiculos/${editItem.id}`, body); toast.success('Vehículo actualizado'); }
      else { await api.post('/catalogos/vehiculos', body); toast.success('Vehículo creado'); }
      setShowModal(false); fetchVehiculos();
    } catch(err) { toast.error(err.response?.data?.message || 'Error'); }
  };

  const handleDelete = async (v) => {
    if (!window.confirm(`¿Desactivar el vehículo ${v.placas}?`)) return;
    try { await api.delete(`/catalogos/vehiculos/${v.id}`); toast.success('Vehículo desactivado'); fetchVehiculos(); }
    catch(e) { toast.error('Error'); }
  };

  const f = (k) => (e) => setForm(p => ({...p, [k]: e.target.value}));

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Catálogo de Vehículos</div>
          <div className="page-subtitle">{vehiculos.length} vehículos registrados</div>
        </div>
        <button className="btn btn-primary" onClick={openCreate}><Plus size={14}/> Nuevo Vehículo</button>
      </div>

      <div className="card">
        <div className="table-wrap">
          {loading ? <div className="loading-screen"><div className="spinner"/></div> : (
            <table>
              <thead>
                <tr><th>Placas</th><th>No. Económico</th><th>Tipo</th><th>Marca / Modelo</th><th>Año</th><th>Cliente</th><th>ID GPS</th><th>Estado</th><th>Acciones</th></tr>
              </thead>
              <tbody>
                {vehiculos.length===0 && <tr><td colSpan={9} className="table-empty">Sin vehículos registrados</td></tr>}
                {vehiculos.map(v => (
                  <tr key={v.id}>
                    <td><span className="font-display" style={{fontSize:15,fontWeight:700,color:'var(--accent)'}}>{v.placas}</span></td>
                    <td><span className="tag">{v.numero_economico||'—'}</span></td>
                    <td style={{fontSize:12}}>{v.tipoVehiculo?.nombre||'—'}</td>
                    <td style={{fontSize:12}}>{[v.marca,v.modelo].filter(Boolean).join(' ')||'—'}</td>
                    <td style={{fontSize:12}}>{v.anio||'—'}</td>
                    <td style={{fontSize:12}}>{v.cliente?.nombre||'—'}</td>
                    <td><span className="font-mono" style={{fontSize:11,color:'var(--text-muted)'}}>{v.id_dispositivo_gps||'—'}</span></td>
                    <td>
                      <span style={{display:'flex',alignItems:'center',gap:4}}>
                        <span style={{width:6,height:6,borderRadius:'50%',background:v.activo?'var(--success)':'var(--danger)'}}/>
                        <span style={{fontSize:11,color:v.activo?'var(--success)':'var(--text-muted)'}}>{v.activo?'Activo':'Inactivo'}</span>
                      </span>
                    </td>
                    <td>
                      <div style={{display:'flex',gap:6}}>
                        <button className="btn-icon" onClick={()=>openEdit(v)}><Pencil size={13}/></button>
                        <button className="btn-icon" onClick={()=>handleDelete(v)} style={{color:'var(--danger)',borderColor:'var(--danger-dim)'}}><Trash2 size={13}/></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal" style={{maxWidth:600}}>
            <div className="modal-header">
              <span className="modal-title"><Truck size={16} style={{marginRight:8}}/>{editItem ? 'Editar' : 'Nuevo'} Vehículo</span>
              <button className="btn-icon" onClick={()=>setShowModal(false)}><X size={16}/></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="grid-3">
                  <div className="form-group"><label className="form-label">Placas *</label><input className="form-control" value={form.placas} onChange={f('placas')} required placeholder="ABC-123-A" style={{textTransform:'uppercase'}}/></div>
                  <div className="form-group"><label className="form-label">No. Económico</label><input className="form-control" value={form.numero_economico} onChange={f('numero_economico')} placeholder="T-001"/></div>
                  <div className="form-group"><label className="form-label">Tipo Vehículo *</label>
                    <select className="form-control" value={form.tipo_vehiculo_id} onChange={f('tipo_vehiculo_id')} required>
                      <option value="">Seleccionar...</option>
                      {tiposVehiculo.map(t=><option key={t.id} value={t.id}>{t.nombre}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Cliente *</label>
                    <select className="form-control" value={form.cliente_id} onChange={f('cliente_id')} required>
                      <option value="">Seleccionar...</option>
                      {clientes.map(c=><option key={c.id} value={c.id}>{c.nombre}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Marca</label><input className="form-control" value={form.marca} onChange={f('marca')} placeholder="Kenworth"/></div>
                  <div className="form-group"><label className="form-label">Modelo</label><input className="form-control" value={form.modelo} onChange={f('modelo')} placeholder="T680"/></div>
                  <div className="form-group"><label className="form-label">Año</label><input className="form-control" type="number" value={form.anio} onChange={f('anio')} placeholder="2022" min="1990" max="2030"/></div>
                  <div className="form-group"><label className="form-label">Color</label><input className="form-control" value={form.color} onChange={f('color')} placeholder="Blanco"/></div>
                  <div className="form-group"><label className="form-label">VIN</label><input className="form-control" value={form.vin} onChange={f('vin')} placeholder="1HGCM82633A004352"/></div>
                  <div className="form-group"><label className="form-label">ID Dispositivo GPS</label><input className="form-control" value={form.id_dispositivo_gps} onChange={f('id_dispositivo_gps')} placeholder="GPS001"/></div>
                  <div className="form-group"><label className="form-label">IMEI</label><input className="form-control" value={form.imei} onChange={f('imei')} placeholder="359123456789012"/></div>
                </div>
                <div className="form-group"><label className="form-label">Notas</label><textarea className="form-control" value={form.notas} onChange={f('notas')} rows={2} placeholder="Notas adicionales..."/></div>
                <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer'}}>
                  <input type="checkbox" checked={!!form.activo} onChange={e=>setForm(p=>({...p,activo:e.target.checked}))} style={{width:16,height:16}}/>
                  <span style={{fontSize:13}}>Vehículo activo</span>
                </label>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setShowModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary"><Check size={14}/> Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
